import React from 'react';
import { RgbaColorPicker } from 'react-colorful';
import { useColorPickerContext } from './ColorPicker.Context';
export var ColorPickerElement = /*#__PURE__*/React.memo(function (_ref) {
  var width = _ref.width;

  var _useColorPickerContex = useColorPickerContext(),
      colorRgb = _useColorPickerContex.colorRgb,
      onChange = _useColorPickerContex.onChange;
  /**
   * Focuses the interactive control from the ColorPicker library.
   * This allows for a smoother mouse -> keyboard update flow.
   */


  return /*#__PURE__*/React.createElement("div", {
    onMouseDown: function handleOnFocusInteractiveControl(event) {
      return event.target.focus();
    }
  }, /*#__PURE__*/React.createElement(RgbaColorPicker, {
    color: colorRgb,
    onChange: onChange,
    width: width
  }));
});